import { render } from "./ReadingPersonalVocabulary.vue?vue&type=template&id=43241866&scoped=true"
import script from "./ReadingPersonalVocabulary.vue?vue&type=script&lang=js"
export * from "./ReadingPersonalVocabulary.vue?vue&type=script&lang=js"

import "./ReadingPersonalVocabulary.vue?vue&type=style&index=0&id=43241866&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43241866"]])

export default __exports__